const FormAuth = {
  parts: [
    'header',
    'title',
    'description',
    'descriptionText',
    'descriptionBold',
    'descriptionBlack',
    'subtitle',
    'buttonContainer',
    'buttonContainerRegisterForm',
    'buttonContainerStandardLoginForm',
    'buttonContainerPasswordlessLogin',
    'buttonGroup',
    'buttonSubmit',
    'buttonOutline',
    'divider',
    'policy',
    'policyText',
    'policyLink',
    'buttonForgotPassword',
    'readOnlyEmailContainer',
    'readOnlyEmailLabel',
    'readOnlyEmailValue',
    'linkSentViewStack',
    'linkSentMessage',
    'linkSentHint',
    'socialLoginContainer',
    'socialLoginButton',
    'contentsContainer',
    'container',
    'contactInfoContainer',
    'passwordlessLoginStack',
  ],
  baseStyle: {
    header: {
      gap: 4,
    },
    headerResetPassword: {
      gap: 4,
    },
    contactInfoContainer: {
      sx: {
        '& .contact-info-stack:not(:has(.chakra-stack > .chakra-button)):not(:has(.chakra-stack.text-stack))': {
          gap: 0,
        },
      },
    },
    passwordlessLoginStack: {
      gap: {base: 4, lg: 8},
      sx: {
        '.login-page-content &': {
          gap: {base: 4, lg: 8},
        },
      },
    },
    title: {
      color: 'brandColors.greyscale90',
      fontSize: {base: '28px', md: '32px'},
      fontStyle: 'normal',
      fontWeight: 'medium',
      lineHeight: '120%',
      letterSpacing: {base: '-0.28px', md: '0'},
    },
    subtitle: {
      color: 'brandColors.greyscale',
      fontSize: 'md',
      fontStyle: 'normal',
      fontWeight: 'semibold',
      lineHeight: '120%',
    },
    description: {
      color: 'brandColors.greyscale90',
      fontSize: 'md',
      fontStyle: 'normal',
      fontWeight: 'normal',
      lineHeight: '160%',
      letterSpacing: '0',
    },
    descriptionText: {
      color: 'brandColors.greyscale80',
      fontSize: '14px',
      lineHeight: '120%',
    },
    descriptionBold: {
      color: 'brandColors.greyscale',
      fontSize: '16px',
      fontWeight: '600',
      lineHeight: '120%',
    },
    descriptionBlack: {
      color: 'black',
    },
    buttonContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: {base: 6, md: 8},
      mt: {base: 6, md: 8},
    },
    buttonContainerRegisterForm: {
      gap: '12px',
      mt: 0,
    },
    buttonContainerStandardLoginForm: {
      gap: 4,
      mt: 0,
    },
    buttonContainerPasswordlessLogin: {
      display: 'flex',
      flexDirection: 'column',
      gap: {base: 6, md: 8},
    },
    buttonGroup: {
      gap: 4,
    },
    buttonSubmit: {
      display: 'flex',
      height: 13.5,
      py: 4,
      px: 12,
      justifyContent: 'center',
      alignItems: 'center',
      gap: 2,
      alignSelf: 'stretch',
      color: 'white',
      textAlign: 'center',
      fontSize: 'sm',
      fontStyle: 'normal',
      fontWeight: 'semibold',
      lineHeight: '120%',
      borderRadius: 'base',
      border: '1px solid',
      borderColor: 'brandColors.greyscale',
      backgroundColor: 'brandColors.greyscale',
      _hover: {
        background: 'brandColors.greyscale80',
      },
    },
    buttonOutline: {
      display: 'flex',
      height: 13.5,
      py: 4,
      px: 12,
      justifyContent: 'center',
      alignItems: 'center',
      gap: 2,
      alignSelf: 'stretch',
      color: 'brandColors.greyscale',
      textAlign: 'center',
      fontSize: 'sm',
      fontStyle: 'normal',
      fontWeight: 'semibold',
      lineHeight: '120%',
      borderRadius: 'base',
      border: '1px solid',
      borderColor: 'brandColors.greyscale90',
      backgroundColor: 'transparent',
      _hover: {
        background: 'brandColors.greyscale10',
      },
      sx: {
        '& svg': {
          width: 5,
          height: 5,
          mr: 0,
        },
      },
    },
    divider: {
      display: 'flex',
      gap: 2,
      alignItems: 'center',
      whiteSpace: 'nowrap',
      color: 'brandColors.primaryText',
      fontSize: 'md',
      fontStyle: 'normal',
      fontWeight: 'normal',
      lineHeight: '120%',
      sx: {
        '&:before, &:after': {
          content: '""',
          display: 'block',
          height: '1px',
          width: 'full',
          background: 'brandColors.greyscale10',
        },
      },
    },
    policy: {
      gap: 4,
    },
    policyText: {
      color: 'brandColors.greyscale60',
      fontSize: 'xs',
      fontStyle: 'normal',
      fontWeight: 'normal',
      lineHeight: '140%',
    },
    policyLink: {
      color: 'brandColors.primaryDarkLinen',
      fontWeight: 'medium',
    },
    buttonForgotPassword: {
      color: 'brandColors.primaryDarkLinen',
      fontSize: {base: 'sm', md: 'md'},
      fontStyle: 'normal',
      fontWeight: {base: '400', md: '600'},
      lineHeight: 'base',
      textDecorationLine: 'underline',
      textUnderlineOffset: '0.35em',
      _hover: {
        textDecoration: 'none',
      },
      sx: {
        'paddingX': {base: 0, lg: 0},
        '.login-page-content &': {
          fontSize: '14px',
          fontWeight: '500',
          lineHeight: '120%',
        },
      },
    },
    readOnlyEmailContainer: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      gap: 1,
      padding: '8px 18px',
      borderRadius: 'base',
      border: '1px solid',
      borderColor: 'brandColors.greyscale10',
      backgroundColor: 'brandColors.greyscale5',
      height: '54px',
    },
    readOnlyEmailLabel: {
      color: 'brandColors.primaryDarkLinen',
      fontSize: 'xs',
      fontStyle: 'normal',
      fontWeight: 'normal',
      lineHeight: '120%',
    },
    readOnlyEmailValue: {
      color: 'brandColors.greyscale',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '120%',
    },
    linkSentViewStack: {
      display: 'flex',
      flexDirection: 'column',
      gap: 6,
    },
    linkSentMessage: {
      color: 'brandColors.greyscale90',
      fontSize: {base: 'sm', md: 'md'},
      fontWeight: 600,
      lineHeight: 'base',
    },
    linkSentHint: {
      color: 'brandColors.greyscale80',
      fontFamily: 'body',
      fontSize: {base: 'sm', md: 'md'},
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '140%',
      sx: {
        '.login-page-content &': {
          fontSize: '14px',
          lineHeight: '120%',
          marginY: {base: 2, lg: 0},
        },
      },
    },
    socialLoginContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: 6,
    },
    socialLoginButton: {
      display: 'flex',
      flex: 1,
      height: 13.5,
      py: 4,
      px: 12,
      justifyContent: 'center',
      alignItems: 'center',
      gap: 2,
      alignSelf: 'stretch',
      color: 'brandColors.greyscale',
      textAlign: 'center',
      fontSize: 'sm',
      fontStyle: 'normal',
      fontWeight: 'semibold',
      lineHeight: '120%',
      borderRadius: 'base',
      border: '1px solid',
      borderColor: 'brandColors.greyscale90',
      backgroundColor: 'transparent',
      _hover: {
        background: 'brandColors.greyscale10',
      },
      sx: {
        '& svg': {
          width: 5,
          height: 5,
          mr: 0,
        },
      },
    },
    contentsContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: {base: 4, lg: 4},
    },
    container: {},
  },

  variants: {
    /** Login page – default styling from baseStyle */
    login: {
      buttonContainerStandardLoginForm: {
        marginTop: {base: '24px', lg: '32px'},
        gap: {base: '24px', lg: '32px'},
      },
    },

    checkout: {
      buttonSubmit: {
        height: 13.5,
        fontFamily: 'body',
        fontWeight: 600,
        fontVariantNumeric: 'lining-nums proportional-nums',
        fontSize: {base: 'sm', md: 'md'},
        lineHeight: 'base',
        textAlign: 'center',
        transition: 'all 0.2s ease',
        _hover: {
          bg: 'white',
          background: 'white',
          borderColor: 'brandColors.greyscale',
          color: 'brandColors.greyscale',
        },
        _active: {
          bg: 'white',
          background: 'white',
          borderColor: 'brandColors.greyscale',
          color: 'brandColors.greyscale',
        },
      },
      buttonOutline: {
        height: 13.5,
        fontFamily: 'body',
        fontWeight: 600,
        fontVariantNumeric: 'lining-nums proportional-nums',
        fontSize: {base: 'sm', md: 'md'},
        lineHeight: 'base',
        textAlign: 'center',
        transition: 'all 0.2s ease',
        _hover: {
          bg: 'brandColors.greyscale',
          background: 'brandColors.greyscale',
          borderColor: 'brandColors.greyscale',
          color: 'white',
        },
        _active: {
          bg: 'brandColors.greyscale',
          background: 'brandColors.greyscale',
          borderColor: 'brandColors.greyscale',
          color: 'white',
        },
      },
      buttonForgotPassword: {
        marginBottom: {base: 2, lg: 6},
      },
      socialLoginContainer: {
        display: 'flex',
        flexDirection: {base: 'column', lg: 'row'},
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: 6,
        mt: 0,
      },
      socialLoginButton: {
        height: 13.5,
        py: 3,
        px: 6,
        fontFamily: 'body',
        fontWeight: 600,
        fontVariantNumeric: 'lining-nums proportional-nums',
        fontSize: {base: 'sm', md: 'md'},
        lineHeight: 'base',
        textAlign: 'center',
        transition: 'all 0.2s ease',
        _hover: {
          bg: 'brandColors.greyscale',
          background: 'brandColors.greyscale',
          borderColor: 'brandColors.greyscale',
          color: 'white',
        },
        _active: {
          bg: 'brandColors.greyscale',
          background: 'brandColors.greyscale',
          borderColor: 'brandColors.greyscale',
          color: 'white',
        },
      },
      divider: {
        marginTop: 2,
        marginBottom: 2,
        fontSize: {base: 'sm', md: 'md'},
      },
    },
  },

  defaultProps: {
    variant: 'login',
  },
};

export default FormAuth;
